// Điểm vào trang web Boss: kiểm phiên → đăng nhập hoặc vào khung; router hash; WS /ui; nút DỪNG TẤT CẢ trên mọi màn.
import { api, errMsg, setUnauthorizedHandler } from "./api";
import { $, clear, confirmBox, dongHopTrang, h, toast } from "./dom";
import { apDungRun, docKyThuat, loadBots, store, upsertBot } from "./store";
import { cauBaoChuyenHuong, chuyenHuong } from "./chuyen-huong"; // N11: địa chỉ cũ → Kịch bản / Lịch sử chạy (khi chưa bật Chế độ kỹ thuật)
import { renderKichBanTuBot } from "./pages/kich-ban-tu-bot";
import { uiSocket } from "./ws";
import { onNoticePush, startInbox, stopInbox, toggleInbox } from "./notices";
import { renderAnnounce } from "./pages/announce";
import { renderModelPage, renderWarnPage } from "./pages/quan-ly";
import { renderBanDo } from "./pages/ban-do";
import type { TotpState, User } from "./types";
import { renderLogin } from "./pages/login";
import { renderBots } from "./pages/bots";
import { renderJobs } from "./pages/jobs";
import { renderJobNew } from "./pages/job-new";
import { renderJobDetail } from "./pages/job-detail";
import { renderRunDetail } from "./pages/run-detail";
import { renderHistory } from "./pages/history";
import { renderStats } from "./pages/stats";
import { renderSettings } from "./pages/settings";
import { renderBundles } from "./pages/bundles";
import { renderLenh } from "./pages/lenh";
import { renderUsers } from "./pages/users";
import { renderAudit } from "./pages/audit";
import { renderCompare } from "./pages/compare";
import { renderWorks } from "./pages/works";
import { renderNhomNick } from "./pages/nhom-nick";
import { renderCaiBot } from "./pages/cai-bot";
import { renderKhoMau, renderKhoMauMot } from "./pages/kho-mau";
import { renderKichBan, renderKichBanDs } from "./pages/kich-ban";
import { renderChoDuyet } from "./pages/tu-sua";
import { renderSoKinhNghiem } from "./pages/so-kinh-nghiem";
import { renderTroLy } from "./pages/tro-ly";
import { renderSanPham, renderSanPhamDs } from "./pages/san-pham";
import { renderKhoVideo } from "./pages/kho-video"; // Kho video (06/10/2026): tải video lên, sửa mô tả, nhãn, đăng ngay, lịch sử đăng
import { renderKhoAnh } from "./pages/kho-anh"; // Kho ảnh (05/10/2026): tải ảnh lên, album, nhãn — bước bình luận kèm ảnh chọn từ đây
import { quenTenKb } from "./ten-kb";
import { renderGoiDs, renderGoiDung } from "./pages/goi-seeding";
import { renderChuoi, renderChuoiDs } from "./pages/chuoi";
import { renderLichChay } from "./pages/lich-chay";
import { batGoiYCuonBang } from "./cuon-bang";
import { batMauKhung } from "./khung-mau"; // (05/10) khung mọi trang: dải tiêu đề + viền màu riêng, khung liền nhau khác màu
import { batGiaiThich } from "./goi-y"; // GIAO DIỆN TỔNG 2026-10: chữ giải thích → nút ⓘ (hiện khi rê chuột / Tab / chạm)
import { batLuoiTrang } from "./luoi-trang";
import { batNganTruot, danhDauNeuNgan, danhDauVeLai, dongNgan, ganDonNgan, goNgan, layVeLai, layYeuCauNgan, moNgan, nganDangMo, tenNgan } from "./ngan-truot"; // A2 (10/10/2026): việc nhanh mở ở ngăn bên phải // GIAO DIỆN TỔNG 2026-10: dấu lưới hai cột (thay :has() đắt trong style.css)

export type Cleanup = (() => void) | void;
export type PageRender = (root: HTMLElement, params: Record<string, string>, query: URLSearchParams) => Promise<Cleanup> | Cleanup;

interface Route { name: string; pattern: RegExp; keys: string[]; render: PageRender }
const ROUTES: Route[] = [];
function route(name: string, path: string, render: PageRender): void {
  const keys: string[] = [];
  const src = path.replace(/:([a-zA-Z]+)\*?/g, (m, k: string) => { keys.push(k); return m.endsWith("*") ? "(.+)" : "([^/?]+)"; });
  ROUTES.push({ name, pattern: new RegExp(`^${src}/?$`), keys, render });
}
route("bots", "/bots", renderBots);
route("jobs-new", "/jobs/new", renderJobNew); // N11: chỉ còn trong Chế độ kỹ thuật (chưa bật → chuyenHuong sang #/kich-ban)
route("jobs", "/jobs/:id", renderJobDetail); // Tiến độ lần chạy — giữ cho mọi người (Kịch bản, Lịch, Cài đặt trỏ tới)
route("jobs", "/jobs", renderJobs);
route("history", "/runs/:key*", renderRunDetail);
route("history", "/history", renderHistory);
route("stats", "/stats", renderStats);
route("bundles", "/bundles", renderBundles);
route("lenh", "/lenh", renderLenh);
route("settings", "/settings", renderSettings);
route("users", "/users", renderUsers); // gói J: chỉ super (trang tự báo "Không có quyền")
route("audit", "/audit", renderAudit);
route("announce", "/announce", renderAnnounce); // Super soạn thông báo chữ/ảnh gửi cho Boss
route("canh-bao", "/canh-bao", renderWarnPage); // danh mục "Quản lý các Boss": cảnh báo người làm kém (chỉ Super)
route("ban-do", "/ban-do", renderBanDo); // danh mục "Quản lý các Boss": bản đồ giao diện — thao tác theo mạng, sức khoẻ, phát hành (chỉ Super)
route("mo-hinh-ai", "/mo-hinh-ai", renderModelPage); // danh mục "Quản lý các Boss": mô hình AI dùng chung (chỉ Super)
route("compare", "/compare", renderCompare); // super: mọi Boss + nhóm; Boss: nhóm mình được xem
route("works", "/works", renderWorks); // nơi bot đã đăng/bình luận — mở lại xem, chống làm trùng
route("nhom-nick", "/nhom-nick", renderNhomNick); // nhóm Facebook của từng nick + trạng thái, lọc theo tên nhóm
route("cai-bot", "/cai-bot", renderCaiBot); // nút "Download và Hướng Dẫn" trên thanh đầu: bản cài bot mới nhất + hướng dẫn cài
route("kich-ban", "/kich-ban/tu-bot/:ten", renderKichBanTuBot); // N11: kịch bản HỌC TRÊN BOT (bundle cũ, không sơ đồ) — chỉ chạy; TRƯỚC /kich-ban/:id
route("kich-ban", "/kich-ban/:id", renderKichBan); // Kịch bản sơ đồ (GĐ1): một kịch bản — sơ đồ bước, sửa, nháp, chạy thật, xuất
route("kich-ban", "/kich-ban", renderKichBanDs); // Kịch bản sơ đồ: gõ mong muốn → AI viết; danh sách kịch bản
route("kho-mau", "/kho-mau/:id", renderKhoMauMot); // Kho mẫu (09/10/2026): Cài đặt cơ bản của một mẫu → Tạo kịch bản
route("kho-mau", "/kho-mau", renderKhoMau); // Kho mẫu: mẫu Super cấp phát, xếp theo mục tiêu
route("goi-seeding", "/goi-seeding/:id", renderGoiDung); // Gói seeding: một gói đã dùng (id) hoặc trình hướng dẫn 4 bước (id "moi")
route("goi-seeding", "/goi-seeding", renderGoiDs); // Gói seeding: gói có sẵn + gói của bạn
route("chuoi", "/chuoi/:id", renderChuoi); // Chuỗi kịch bản (05/10/2026): nhiều kịch bản chạy lần lượt trên từng bot — thứ tự, bot, nghỉ, khi lỗi, chạy, tiến độ, tần suất
route("chuoi", "/chuoi", renderChuoiDs); // Chuỗi kịch bản: danh sách + tạo (?them=<kịch bản>)
route("lich", "/lich", renderLichChay); // Lịch chạy (05/10, N10): mọi lịch tự chạy — chọn kịch bản trước rồi bot, múi giờ VN, chế độ theo chạy thử sạch
route("cho-duyet", "/cho-duyet", renderChoDuyet);
route("so-kinh-nghiem", "/so-kinh-nghiem", renderSoKinhNghiem); // GĐ4a: bài học AI đã học (dạy, sửa, tắt, xoá, xác nhận, bằng chứng) // GĐ3: mọi bước rủi ro cao đang chờ duyệt của mọi bot (sửa câu, bỏ, duyệt tất cả) + đề xuất sửa + bot tạm dừng
route("san-pham", "/san-pham/:id", renderSanPham); // Thư viện sản phẩm: tạo/sửa một sản phẩm (id "moi" = tạo mới; ?kb=<id> lưu xong quay lại kịch bản)
route("san-pham", "/san-pham", renderSanPhamDs); // Thư viện sản phẩm: danh sách + nhập hồ sơ plugin
route("kho-anh", "/kho-anh", renderKhoAnh); // Kho ảnh: tải ảnh lên (nhiều tệp, kéo-thả), chú thích, album, nhãn, xoá; ảnh sản phẩm hiện như album "Sản phẩm: <tên>"
route("kho-video", "/kho-video", renderKhoVideo); // Kho video: tải nhiều video (nút lớn / kéo-thả, tiến độ, huỷ), thẻ video, lọc Chưa đăng / Đã đăng / Hết lượt, lịch sử đăng
route("tro-ly", "/tro-ly", renderTroLy); // GĐ4b: khung chat Trợ lý AI — hỏi về dữ liệu của mình, trích nguồn, thẻ đề xuất (người bấm mới làm)

let cleanup: Cleanup;
let routeGen = 0;
let baoChuyen = ""; // câu dải báo sau khi chuyển từ địa chỉ cũ (một lần)
let trangDuoi: string | null = null; // địa chỉ (không #) của trang đang vẽ ở #main — ngăn trượt mở đè lên trang này

/** Dải nhỏ đầu trang: địa chỉ cũ vừa được chuyển tới đây (có nút ×). Chữ dựng bằng textContent. */
function daiChuyenHuong(cau: string): HTMLElement {
  const dai = h("div", { class: "dai-chuyen", role: "status", "data-testid": "dai-chuyen-huong" }, h("span", { class: "grow" }, cau));
  dai.append(h("button", { type: "button", class: "kb-noi-x", "aria-label": "Ẩn dải báo", title: "Ẩn dải báo này", onclick: () => dai.remove() }, "×"));
  return dai;
}

/** N11: hiện/ẩn nhóm menu "Kỹ thuật" theo store.kyThuat (Cài đặt gọi lại khi Super bật/tắt). */
export function apDungKyThuat(): void {
  document.querySelectorAll<HTMLElement>("#nav [data-ky-thuat]").forEach((a) => { a.hidden = !store.kyThuat; });
}

export function go(hash: string): void {
  const h2 = hash.replace(/^#/, "");
  if ("#" + h2 === location.hash) return;
  // Đang mở ngăn mà sang trang thường → THAY mục lịch sử của ngăn: Back sau đó về thẳng trang trước (không phải bấm Back thừa qua ngăn).
  const nm = nganDangMo();
  if (nm && h2 === nm.duoi) { danhDauVeLai(); history.back(); return; } // về đúng trang dưới: đóng ngăn + vẽ lại trang dưới (số liệu mới)
  if (nm && !tenNgan(h2.split("?")[0]!)) { location.replace("#" + h2); return; }
  if (trangDuoi !== null) danhDauNeuNgan(h2);
  location.hash = h2;
}

async function dispatch(): Promise<void> {
  if (!store.user) return;
  const raw = location.hash.replace(/^#/, "") || "/bots";
  const qi = raw.indexOf("?");
  const path = qi >= 0 ? raw.slice(0, qi) : raw;
  const query = new URLSearchParams(qi >= 0 ? raw.slice(qi + 1) : "");
  // A2 ngăn trượt: Back về đúng trang bên dưới → chỉ gỡ ngăn (trang dưới giữ nguyên, không tải lại); sang trang thường → gỡ ngăn rồi vẽ như cũ.
  const muonNgan = layYeuCauNgan();
  const nm = nganDangMo();
  if (nm) {
    if (raw === nm.duoi) { goNgan(); if (!layVeLai()) { veDemChoDuyet(); return; } }
    if (!tenNgan(path)) goNgan();
  }
  // N11: địa chỉ cũ (Phát lệnh mới / Ra lệnh / Kho kịch bản / Lệnh chạy) → trang mới. replaceState: không thêm mục lịch sử → Back về trang
  // TRƯỚC đó, không lặp lại địa chỉ cũ. Dải báo hiện một lần trên trang đích.
  const dich = chuyenHuong(path, query, store.kyThuat);
  if (dich) {
    history.replaceState(null, "", "#" + dich);
    baoChuyen = cauBaoChuyenHuong(path);
    return dispatch();
  }
  const r = ROUTES.find((x) => x.pattern.test(path));
  if (!r) {
    // Gốc "#/" hoặc "#/login" (đã đăng nhập) → về Bot như cũ. Địa chỉ lạ (gõ sai, liên kết cũ) → NÓI RÕ "Không có trang này" + nút về Bot, không im lặng đổi trang.
    if (path === "/" || path === "" || path === "/login") { location.hash = "/bots"; return; }
    ++routeGen;
    dongHopTrang();
    if (typeof cleanup === "function") cleanup();
    cleanup = undefined;
    document.querySelectorAll<HTMLAnchorElement>("#nav a").forEach((a) => { a.classList.remove("active"); a.removeAttribute("aria-current"); });
    const main = $("main");
    clear(main);
    window.scrollTo(0, 0);
    main.append(h("div", { class: "card", "data-testid": "khong-co-trang" },
      h("h2", {}, "Không có trang này"),
      h("p", { class: "muted" }, "Địa chỉ ", h("code", {}, `#${path}`), " không đúng hoặc trang đã bị bỏ."),
      h("a", { class: "btn pri", href: "#/bots", "data-testid": "khong-co-trang-ve-bot", title: "Về trang Bot" }, "Về trang Bot")));
    return;
  }
  const m = r.pattern.exec(path)!;
  const params: Record<string, string> = {};
  r.keys.forEach((k, i) => { params[k] = decodeURIComponent(m[i + 1] ?? ""); });
  if (tenNgan(path) && (nganDangMo() || (muonNgan && trangDuoi !== null && trangDuoi !== raw))) {
    dongHopTrang();
    const { than, gen } = moNgan(path, nganDangMo()?.duoi ?? trangDuoi!);
    try {
      ganDonNgan(gen, await r.render(than, params, query));
    } catch (e) {
      than.append(h("div", { class: "err-box", "data-testid": "page-error" }, "Không tải được: ", errMsg(e)));
    }
    veDemChoDuyet();
    return;
  }
  trangDuoi = raw;
  const g = ++routeGen;
  dongHopTrang(); // L-82: hộp thoại của trang cũ không che trang mới
  quenTenKb(); // L-78: mỗi lần mở trang hỏi lại tên kịch bản (đổi tên ở trang kịch bản thì trang khác thấy ngay)
  if (typeof cleanup === "function") cleanup();
  cleanup = undefined;
  document.querySelectorAll<HTMLAnchorElement>("#nav a").forEach((a) => {
    const on = a.dataset.route === r.name;
    a.classList.toggle("active", on);
    if (on) a.setAttribute("aria-current", "page"); else a.removeAttribute("aria-current");
    // Màn hẹp: menu là dải cuộn ngang ở đáy → đưa mục đang mở vào tầm nhìn (không cuộn trang). Chỉ ≤ 1023 px: ở màn rộng menu là bảng ẩn
    // (GIAO DIỆN TỔNG 2026-10) — scrollIntoView dời "điểm bắt đầu Tab" của Chromium vào bảng ẩn, Tab đầu tiên nhảy qua nút ☰.
    if (on && window.matchMedia("(max-width: 1023px)").matches) a.scrollIntoView({ block: "nearest", inline: "nearest" });
  });
  const main = $("main");
  clear(main);
  window.scrollTo(0, 0);
  const bao = baoChuyen;
  baoChuyen = "";
  try {
    const c = await r.render(main, params, query);
    if (g === routeGen) cleanup = c;
    else if (typeof c === "function") c();
    if (bao && g === routeGen) main.prepend(daiChuyenHuong(bao));
    veDemChoDuyet();
  } catch (e) {
    if (g !== routeGen) return;
    clear(main);
    main.append(h("div", { class: "err-box", "data-testid": "page-error" }, "Không tải được trang: ", errMsg(e)),
      h("p", {}, h("button", { type: "button", title: "Tải lại trang này từ máy chủ", onclick: () => void dispatch() }, "Thử lại")));
  }
}

/** Đặt/gỡ huy hiệu số trên một mục menu (qua data-count + ::after — không đổi chữ của liên kết). */
function datHuyHieu(route: string, n: number, moTa: string): void {
  const a = document.querySelector<HTMLAnchorElement>(`#nav a[data-route="${route}"]`);
  if (!a) return;
  if (n) { a.dataset.count = String(n); a.setAttribute("aria-description", moTa); }
  else { delete a.dataset.count; a.removeAttribute("aria-description"); }
}

/**
 * Khung trang theo dữ liệu bot đang có: huy hiệu "Bot" (bot chờ duyệt/OTP) + V3 huy hiệu "Chờ duyệt" (số câu chờ duyệt — trước đây chỉ có ở Bot nên
 * người dùng không biết mở Chờ duyệt); L4 nút DỪNG TẤT CẢ mờ khi không có lần chạy nào; L5 nút Download chỉ đỏ nháy khi cần (chưa có bot / bot cũ).
 */
function veDemChoDuyet(): void {
  let n = 0, nDuyet = 0, dangChay = false, botCu = false;
  for (const b of store.bots.values()) {
    if (b.online && (b.current?.status === "paused_approval" || b.current?.status === "paused_otp")) n++;
    if (b.online && b.current?.status === "paused_approval") nDuyet++;
    if (b.current) dangChay = true;
    if (b.versionOld) botCu = true;
  }
  datHuyHieu("bots", n, `${n} bot đang chờ bạn duyệt`);
  const daTai = store.botsLoadedAt > 0;
  const soCau = daTai ? nDuyet : store.choDuyetN ?? 0;
  datHuyHieu("cho-duyet", soCau, `${soCau} câu đang chờ bạn duyệt`);
  const cb = document.getElementById("can-ban-nhanh");
  if (cb) {
    const tong = Math.max(n, soCau);
    cb.hidden = !tong;
    const so = cb.querySelector(".can-ban-so");
    if (so) so.textContent = String(tong);
    cb.setAttribute("aria-label", `Cần bạn: ${tong} việc chờ duyệt — mở ngăn Chờ duyệt`);
  }
  const stop = document.getElementById("stop-all");
  if (stop) {
    const nghi = daTai && !dangChay;
    stop.classList.toggle("stop-nghi", nghi);
    stop.title = nghi
      ? "Hiện không có lần chạy nào — vẫn bấm được để huỷ các lệnh đang chờ giãn cách (có hộp xác nhận, ghi vào nhật ký hệ thống)"
      : "Dừng ngay mọi lần chạy đang diễn ra hoặc chờ duyệt và huỷ các lệnh đang chờ của bạn — có hộp xác nhận, được ghi vào nhật ký hệ thống";
  }
  const tai = document.getElementById("tai-bot");
  if (tai) {
    const canTai = !daTai || !store.bots.size || botCu;
    tai.classList.toggle("nut-do-nhay", canTai);
    tai.classList.toggle("pri", !canTai);
  }
}

/** V10: menu đáy (≤ 1023 px) cuộn ngang — nút "‹ / ›" kèm số mục còn khuất ở mỗi phía, bấm để cuộn; hết mục khuất thì ẩn. */
function batGoiYCuonMenu(): void {
  const nav = document.getElementById("nav");
  const trai = document.getElementById("nav-cuon-trai") as HTMLButtonElement | null;
  const phai = document.getElementById("nav-cuon-phai") as HTMLButtonElement | null;
  if (!nav || !trai || !phai) return;
  let hen = 0;
  const ve = (): void => {
    hen = 0;
    const ngang = getComputedStyle(nav).flexDirection === "row" && nav.scrollWidth > nav.clientWidth + 1;
    const r = nav.getBoundingClientRect();
    let tr = 0, ph = 0;
    if (ngang) for (const a of nav.querySelectorAll<HTMLElement>("a")) {
      if (a.hidden || a.offsetParent === null) continue;
      const b = a.getBoundingClientRect();
      if (b.left < r.left - 4) tr++;
      else if (b.right > r.right - 24) ph++;
    }
    trai.hidden = !tr; phai.hidden = !ph;
    trai.querySelector(".nav-cuon-so")!.textContent = String(tr);
    phai.querySelector(".nav-cuon-so")!.textContent = `+${ph}`;
    trai.setAttribute("aria-label", `Cuộn menu sang trái — còn ${tr} mục`);
    phai.setAttribute("aria-label", `Cuộn menu sang phải — còn ${ph} mục`);
    phai.title = `Còn ${ph} mục menu bên phải — bấm hoặc vuốt ngang để xem`;
    trai.title = `Còn ${tr} mục menu bên trái — bấm hoặc vuốt ngang để xem`;
  };
  const cho = (): void => { if (!hen) hen = requestAnimationFrame(ve); };
  nav.addEventListener("scroll", cho, { passive: true });
  window.addEventListener("resize", cho);
  if (typeof ResizeObserver !== "undefined") new ResizeObserver(cho).observe(nav);
  trai.addEventListener("click", () => nav.scrollBy({ left: -Math.max(160, nav.clientWidth * 0.7), behavior: "smooth" }));
  phai.addEventListener("click", () => nav.scrollBy({ left: Math.max(160, nav.clientWidth * 0.7), behavior: "smooth" }));
  cho();
}

function wireHeader(): void {
  const rt = $("rt");
  document.getElementById("can-ban-nhanh")?.addEventListener("click", () => go("/cho-duyet"));
  uiSocket.onState((on) => {
    rt.classList.toggle("off", !on);
    rt.querySelector(".rt-text")!.textContent = on ? "cập nhật tức thời" : "mất cập nhật tức thời";
  });
  uiSocket.on((ev) => {
    if (ev.type === "bot.changed") {
      // removed:true → bot rời bảng của mình (thu hồi / chuyển sang Boss khác); super nhận tiếp thông điệp cho chủ mới → thêm lại.
      if (ev.removed) { store.bots.delete(ev.bot.id); store.ticked.delete(ev.bot.id); } else upsertBot(ev.bot);
      veDemChoDuyet();
    } else if (ev.type === "run.changed") { apDungRun(ev.run); veDemChoDuyet(); } // huy hiệu Chờ duyệt / DỪNG TẤT CẢ đúng ở MỌI trang
    else if (ev.type === "local.refresh") veDemChoDuyet();
    else if (ev.type === "hello") {
      // Mã bản dựng máy chủ đang phát khác mã nhúng trong trang này = tab mở từ TRƯỚC một lần deploy → đang chạy giao diện cũ (có thể không vẽ được thông báo mới).
      if (ev.build && ev.build !== __BUILD_ID__) $("new-version").hidden = false;
    } else if (ev.type === "notice") {
      // Thông báo có mã (báo cáo/cảnh báo) hiện thành cửa sổ nổi giữa màn hình + nằm lại trong hộp chuông; chỉ thông báo nền không mã mới là toast.
      if (ev.noticeId) onNoticePush(ev);
      else toast(ev.text, ev.level === "err" ? "err" : ev.level === "warn" ? "warn" : "info");
    }
  });
  $("bell").addEventListener("click", () => toggleInbox());
  $("reload-new").addEventListener("click", () => location.reload());
  $("stop-all").addEventListener("click", async () => {
    const btn = $("stop-all") as HTMLButtonElement;
    if (btn.disabled) return;
    const ok = await confirmBox({
      title: "DỪNG TẤT CẢ?",
      text: store.user?.role === "super"
        ? "Dừng mọi lần chạy đang chạy/chờ duyệt của TẤT CẢ Boss và huỷ mọi lệnh đang chờ. Việc này được ghi vào nhật ký hệ thống."
        : "Dừng mọi lần chạy đang chạy/chờ duyệt của bạn và huỷ mọi lệnh đang chờ giãn cách. Việc này được ghi vào nhật ký hệ thống.",
      okText: "Dừng tất cả", danger: true,
    });
    if (!ok) return;
    btn.disabled = true;
    try {
      const r = await api<{ stopped: number; cancelled: number }>("POST", "/api/stop-all", { confirm: true });
      toast(`Đã dừng ${r.stopped} lần chạy, huỷ ${r.cancelled} lệnh`, "warn");
      // Tải lại bot NGAY và báo các trang vẽ lại — không chờ WebSocket: đang mất kết nối (vừa ngắt / đang nối lại) thì thẻ bot còn hiện "Chờ duyệt" của lần chạy đã dừng, bấm Từ chối ra 409 (hạt khỉ 115).
      void loadBots(true).then(() => { uiSocket.emitLocal({ type: "local.refresh" }); }).catch(() => { /* mất mạng: WebSocket sẽ đồng bộ khi nối lại */ });
    } catch (e) {
      toast(errMsg(e), "err");
    } finally {
      btn.disabled = false;
    }
  });
}

function showLogin(): void {
  goNgan();
  trangDuoi = null;
  if (typeof cleanup === "function") cleanup();
  cleanup = undefined;
  routeGen++;
  dongHopTrang(); // L-82: phiên hết hạn giữa lúc mở hộp thoại → hộp cũ không được che màn đăng nhập
  store.user = null;
  store.bots.clear();
  store.botsLoadedAt = 0;
  uiSocket.stop();
  stopInbox();
  $("top").hidden = true;
  $("banner").hidden = true;
  const main = $("main");
  clear(main);
  renderLogin(main, (u) => boot(u));
}

// Gói J: super mà máy chủ bắt buộc TOTP (config.requireSuperTotp) nhưng chưa bật → dải nhắc trên mọi trang tới khi bật xong.
async function checkTotpBanner(u: User): Promise<void> {
  const banner = $("banner");
  banner.hidden = true;
  if (u.role !== "super") return;
  try {
    const t = await api<TotpState>("GET", "/api/me/totp");
    if (store.user?.id !== u.id) return;
    if (t.required && !t.enabled) {
      clear(banner);
      banner.append("Máy chủ yêu cầu Super Boss bật xác thực 2 lớp (TOTP). ", h("a", { href: "#/settings", "data-testid": "totp-banner-link", title: "Mở trang Cài đặt, khối Xác thực 2 lớp" }, "Bật ngay trong Cài đặt"), ".");
      banner.dataset.testid = "totp-banner";
      banner.hidden = false;
    }
  } catch { /* không chặn việc dùng trang; Cài đặt vẫn hiện khối TOTP */ }
}
export function refreshTotpBanner(): void {
  if (store.user) void checkTotpBanner(store.user);
}

function boot(u: User): void {
  store.user = u;
  $("top").hidden = false;
  $("who").textContent = `${u.username} · ${u.role === "super" ? "Super Boss" : "Boss"}`;
  $("avatar").textContent = (u.username.trim()[0] ?? "?").toUpperCase();
  $("who").title = u.role === "super" ? "Bạn là Super Boss: thấy bot của mọi Boss, quản tài khoản và nhật ký hệ thống" : "Bạn là Boss: chỉ thấy và điều khiển bot của mình";
  // Thanh trên ở màn hẹp (chân thanh bên bị ẩn ≤ 1023 px): tên một dòng, vai trò dòng dưới; dấu " · " chỉ hiện khi một dòng.
  const vaiTro = u.role === "super" ? "Super Boss" : "Boss";
  const whoTop = $("who-top");
  clear(whoTop);
  whoTop.append(h("b", { class: "who-top-ten" }, u.username), h("span", { class: "who-top-sep" }, " · "), h("span", { class: "who-top-vai" }, vaiTro));
  whoTop.title = `Đang đăng nhập: ${u.username} (${vaiTro})`;
  document.querySelectorAll<HTMLElement>("#nav [data-super]").forEach((a) => { a.hidden = u.role !== "super"; }); // cả nhãn nhóm "Quản lý các Boss" lẫn các mục của Super
  store.kyThuat = docKyThuat(u); // N11: chỉ Super; localStorage hỏng / bị chặn → tắt
  apDungKyThuat();
  void checkTotpBanner(u);
  // KHÔNG tự gọi loadBots() thêm ở đây: đó là một request mạng phụ chạy song song lúc khởi động, không cần thiết vì
  // trang Bot đã tự tải khi mở, và WS bot.changed/local.refresh cũng gọi veDemChoDuyet(). Số việc chờ duyệt trên menu
  // dùng dữ liệu đã có sẵn trong store; trước khi có dữ liệu thì không hiện số (không sai, chỉ chưa có gì để đếm).
  veDemChoDuyet();
  uiSocket.start();
  startInbox();
  // L9 (rà soát 05/10): trang đầu luôn là Bot — nơi làm việc (việc cần bạn, chờ duyệt, bắt đầu). Trước đây Boss thuộc nhóm so sánh bị đưa thẳng
  // tới bảng xếp hạng So sánh Boss; bảng đó vẫn mở từ menu. Đổi hash ngay (không chờ mạng) nên không còn cảnh vừa bấm trang khác bị kéo ngược (W71 / E27).
  if (!location.hash || location.hash === "#/" || location.hash === "#/login") location.hash = "/bots";
  else void dispatch();
}

async function start(): Promise<void> {
  batGoiYCuonBang(); // bảng rộng hơn khung → "↔ Kéo ngang để xem thêm" + mép phải mờ (mọi trang)
  batMauKhung(); // khung (thẻ có tiêu đề) mọi trang: nhãn màu rõ ràng để không trông như một mảng
  batGoiYCuonMenu(); // menu đáy màn hẹp: nút ‹ / › + số mục còn khuất
  batLuoiTrang(); // ≥ 1200 px: dấu lưới hai cột (luoi-2 / data-luoi-boc) cho style.css
  batGiaiThich(); // mọi trang: đoạn giải thích thành ⓘ cạnh tiêu đề / nhãn
  setUnauthorizedHandler(() => { if (store.user) { toast("Phiên đã hết hạn — đăng nhập lại", "warn"); showLogin(); } });
  window.addEventListener("hashchange", () => void dispatch());
  batNganTruot(go); // A2: bấm liên kết tới lần chạy / mẫu / sản phẩm / chờ duyệt trong trang → mở ở ngăn bên phải
  // L-82: Esc đóng hộp thoại trên cùng (hộp tự xử lý Esc rồi tự gỡ thì đích sự kiện đã rời trang → bỏ qua, không đóng thêm hộp bên dưới).
  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape" || e.defaultPrevented) return;
    if (e.target instanceof Node && !document.contains(e.target)) return;
    if (dongHopTrang(true) === 0 && nganDangMo()) dongNgan(); // không còn hộp nào → Esc đóng ngăn trượt
  });
  wireHeader();
  try {
    const u = await api<User>("GET", "/api/me");
    boot(u);
  } catch (e) {
    showLogin();
    // 401 = chưa đăng nhập, bình thường. Lỗi khác (mạng, 500) → báo để người dùng biết vì sao chưa vào được.
    if ((e as { status?: number }).status !== 401) toast(errMsg(e), "err");
  }
}

void start();
